import { ImageBloc, ImageType } from '@kp/shared/image/image.bloc';

export class ImageRecord {
  constructor(
    public id?: string,
    public userId?: string,
    public type?: ImageType,
    public uuid?: string,
    public originalFilename?: string,
    public url?: string,
    public expirationDate?: string,
    public dateCreated?: string,
    public lastUpdated?: string
  ) {
    this.type = ImageBloc.translateImageType(type);
  }

  deserialize(input: any): ImageRecord {
    if (input == null) {
      return null;
    }
    this.id = input.id;
    this.userId = input.userId;
    this.type = ImageBloc.translateImageType(input.imageType);
    this.uuid = input.imageUUID;
    this.originalFilename = input.originalFileName;
    this.url = input.signedUrl;
    this.expirationDate = input.signedUrlExpirationDate;
    this.dateCreated = input.dateCreated;
    this.lastUpdated = input.dateLastUpdated;

    return this;
  }
}
